import { SearchableDropdownItem } from 'components/SearchableDropdown/constants';

export const Months: SearchableDropdownItem[] = [
    { id: '00', displayName: 'January' },
    { id: '01', displayName: 'February' },
    { id: '02', displayName: 'March' },
    { id: '03', displayName: 'April' },
    { id: '04', displayName: 'May' },
    { id: '05', displayName: 'June' },
    { id: '06', displayName: 'July' },
    { id: '07', displayName: 'August' },
    { id: '08', displayName: 'September' },
    { id: '09', displayName: 'October' },
    { id: '10', displayName: 'November' },
    { id: '11', displayName: 'December' }
];

export const Days: SearchableDropdownItem[] = [
    { id: '01', displayName: '1' },
    { id: '02', displayName: '2' },
    { id: '03', displayName: '3' },
    { id: '04', displayName: '4' },
    { id: '05', displayName: '5' },
    { id: '06', displayName: '6' },
    { id: '07', displayName: '7' },
    { id: '08', displayName: '8' },
    { id: '09', displayName: '9' },
    { id: '10', displayName: '10' },
    { id: '11', displayName: '11' },
    { id: '12', displayName: '12' },
    { id: '13', displayName: '13' },
    { id: '14', displayName: '14' },
    { id: '15', displayName: '15' },
    { id: '16', displayName: '16' },
    { id: '17', displayName: '17' },
    { id: '18', displayName: '18' },
    { id: '19', displayName: '19' },
    { id: '20', displayName: '20' },
    { id: '21', displayName: '21' },
    { id: '22', displayName: '22' },
    { id: '23', displayName: '23' },
    { id: '24', displayName: '24' },
    { id: '25', displayName: '25' },
    { id: '26', displayName: '26' },
    { id: '27', displayName: '27' },
    { id: '28', displayName: '28' },
    { id: '29', displayName: '29' },
    { id: '30', displayName: '30' },
    { id: '31', displayName: '31' }
];